import { useEntryContext } from '../context/EntryContext';

interface Props { fieldKey?: string }

export function EntryRichTextBlock({ fieldKey = 'body' }: Props) {
  const { entry } = useEntryContext();
  const html = entry.dataJson?.[fieldKey] as string | undefined;
  if (!html) return null;
  // Content comes from the CMS backend (trusted source) — same pattern as CollectionEntryPage
  // eslint-disable-next-line react/no-danger
  return (
    <div
      className="prose prose-sm max-w-none text-zinc-700"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
